import {
  hardCodeIsCaesarStone,
  hardCodeIsLowes,
  hardCodeIsMcDermott,
  hardCodeIsModerno,
  hardCodeIsPorcelanosa,
  isProd
} from "../../misc/fabricatorHardcode";

export const isDevMode = () => {
  return window.location.href.includes("dev=1") || document.kvConfig.devMode
};

export const SQFT_POST_MESSAGE_ACTIONS = {
  initialLoad: "initialLoad",
  setQTData: "setQTData",
  closeSqFtCalc: "closeSqFtCalc",
  callResetDataPopup: "callResetDataPopup",
  callChangeLayoutDataPopup: "callChangeLayoutDataPopup",
  userIdleResetCounter: "userIdleResetCounter",
  resetHistory: "resetHistory",
  saveHistory: "saveHistory",
  setNewLayoutOnSqft: "setNewLayoutOnSqft",
  setCanvasCenter: "setCanvasCenter",
  stopRender: "stopRender",
  startRender: "startRender",
};

export const MEASURE_UNITS = {
  Metric: "Metric",
  Imperial: "Imperial",
};

/**
 *
 * This is used only to take shape part id
 * @type {{top_cabinet: string, bottom_cabinet: string, center_island_countertop: string, slabPlaceHolder: string, seamPiece: string, countertop: string, spacer: string, vanity_countertop: string, backsplashPiece: string}}
 */
export const SHAPE_PART_ID = {
  edge: 'edge',
  seamPiece: 'seamPiece',
  backsplashPiece: 'backsplashPiece',
  waterfallPiece: 'waterfallPiece',
  slabPlaceHolder: 'slabPlaceHolder',
  top_cabinet: 'top_cabinet',//
  bottom_cabinet: 'bottom_cabinet',//
  tall_cabinet: 'tall_cabinet', //
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  vanity_cabinet: 'vanity_cabinet',
  vanitie_cabinet_boxes: 'vanitie_cabinet_boxes',
  vanity_cabinet_boxes: 'vanity_cabinet_boxes',
  countertop: 'countertop',
  spacer: 'spacer',
  vanity_countertop: 'vanity_countertop',
  center_island_countertop: 'center_island_countertop',
  front_wall: 'front_wall',

  //appliances
  dishwasher: "dishwasher",
  range: "range",
  hood: "hood",
  fridge: "fridge",
  stove: "stove",
};

export const SQFT_FEATURES = {
  bumpouts: 'bumpouts',
  countertop: 'countertop',
  center_island_countertop: 'center_island_countertop',
  slabs: 'slabs',
  backsplashes: 'backsplashes',
  edges: 'edges',
  radius: 'radius',
  corners: 'corners',
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  vanity_accent: 'vanity_accent',
  vanity_countertop: 'vanity_countertop',
  vanity_backsplash: 'vanity_backsplash',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
  top_cabinet: 'top_cabinet',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  top_handle: 'top_handle',
  bottom_cabinet: 'bottom_cabinet',
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  bottom_handle: 'bottom_handle',
  tall_cabinet: 'tall_cabinet',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  vanity_cabinet: 'vanity_cabinet',
  vanitie_cabinet_boxes: 'vanitie_cabinet_boxes',
  vanity_cabinet_boxes: 'vanity_cabinet_boxes',
  crown_molding: 'crown_molding',
  handle: 'handle',
  underlayment: 'underlayment',
  wall_door_end_accessory: 'wall_door_end_accessory',
  base_door: 'base_door',
  island_panel: 'island_panel',
  refridgerator_panel: 'refridgerator_panel',
  end_cap: 'end_cap',
  hinge: 'hinge',
};

export const APPLIANCE_PART_IDS = [
  SHAPE_PART_ID.dishwasher,
  SHAPE_PART_ID.hood,
  SHAPE_PART_ID.fridge,
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.range
]

export const APPLIANCE_UPPER_PART_IDS = [
  SHAPE_PART_ID.hood,
]

export const APPLIANCE_LOWER_PART_IDS = [
  SHAPE_PART_ID.dishwasher,
  SHAPE_PART_ID.fridge,
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.range
]

export const FEATUREGROUP_PART_ID = {
  specialty_cut_and_designs: 'specialty_cut_and_designs'
}

export const SHAPE_ROTATE_DIRECTION = {
  right: 0,
  left: 1,
};

export const ALIGN = {
  right: 'right',
  left: 'left',
  center: 'center',
};

export const SHAPE_TYPE = {
  polygon: "polygon",
  square: "square",
  wideangle: "wideangle",
  horseshoe: "horseshoe",
  appliances: "appliances",
};

export const RENDER_TEMPLATES = {
  default: "default",
  disabled: "disabled",
  linesOnly: "linesOnly",
  filledPrimary: "filledPrimary",
  accordingToFeature: "accordingToFeature",
  filledActive: "filledActive",
  filledRed: "filledRed",
};

/**
 * NAVIGATION
 */
export const SIDEBAR2_BUTTONS = [
  {
    menu: "summary",
    classNames: "button--parent button--summary",
    text: "mobile.summary",
    hasMenu: true
  },
  // {
  //   menu: "settings",
  //   classNames: "button--parent button--settings",
  //   text: "settings",
  //   hasMenu: true
  // }
];

export const SIDEBAR_BUTTONS_MENU = {
  move: "move",
  shapes: "shapes",
  layouts: "layouts",
  summary: "summary",
  delete: "delete",
  cabinetset: "cabinetset"
}

export const SIDEBAR_SLAB_BUTTONS = {
  move: "move",
  //moveSlab: "moveSlab",
  rotate: "rotate",
  loadSlab: "loadSlab",
  seam: "seam",
  duplicate: "duplicate",
  delete: "delete",
};

export const MOVABLE_IMAGE_TYPES = {
  slabImage: "slabImage",
};

export const SIDEBAR_SLAB_SEAM_BUTTONS = {
  addFreeSeam: "addFreeSeam", //todo enable when ready
  addSeamHorizontal: "addSeamHorizontal",
  addSeamVertical: "addSeamVertical",
  undoSeam: "undoSeam",
  resetSeams: "resetSeams",
};

/**
 * remember to update SIDEBAR_HIDDEN_BUTTONS (names should be the same)
 */
export const SIDEBAR_NAVIGATION_BUTTONS = {
  move: "move",
  //freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  radius: "radius",
  edge: "edge",
  backsplash: "backsplash",
  end_cap: "end_cap",
  appliances: "appliances",
  //angle: "angle",
  bumpout: "bumpout",
  label: "label",
  text: "text",
  ...((!hardCodeIsLowes()) && { mitered: "mitered" }),
  ...((!hardCodeIsMcDermott() && !hardCodeIsLowes()) && { toolWaterfall: "toolWaterfall" }),
  ...((!isProd && (hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode())) && { toolUnderlayment: "toolUnderlayment" }),
  duplicate: "duplicate",
};

export const SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS = {
  move: "move",
  freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  edge: "edge",
  bumpout: "bumpout",
  mitered: "mitered",
  ...((hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode()) && {toolWaterfall: "toolWaterfall"}),
  appliances: "appliances",
  label: "label",
  text: "text",
  duplicate: "duplicate",
};

export const SIDEBAR_NAVIGATION_CABINET_BUTTONS = {
  move: "move",
  resize: "resize",
  rotate: "rotate",
  lower: "lower",
  upper: "upper",
  tall: "tall",
  centerIsland: "centerIsland",
  spacer: "spacer",
  //style: "style",
  wall: "wall",
  crown_molding: "crown_molding",
  handles: "handles",
  hinge: "hinge",
  // top_handle: "top_handle",
  // bottom_handle: "bottom_handle",
  end_panel: "end_panel",
  appliances: "appliances", // disable appliances for caes
  text: "text",
};

export const SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS = {
  move: "move",
  resize: "resize",
  rotate: "rotate",
  vanity: "vanity",
  spacer: "spacer",
  wall: "wall",
  appliances: "appliances",
  text: "text",
};

export const SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS = {
  //move: "move",
  top_cabinet: "top_cabinet",
  bottom_cabinet: "bottom_cabinet",
  tall_cabinet: "tall_cabinet",
  //crown_molding: "crown_molding",
  handles: "handles",
  centerIsland: "centerIsland",
  //vanity: "vanity",
  //spacer: "spacer",
  //wall: "wall",
  //appliances: "appliances",
  //text: "text",
};

export const SIDEBAR_NAVIGATION_3D_BATHROOM_CABINET_BUTTONS = {
  //move: "move",
  vanity_cabinet: "vanity_cabinet",
  vanity_countertop: "vanity_countertop",
  //vanity: "vanity",
  //spacer: "spacer",
  //wall: "wall",
  //appliances: "appliances",
  //text: "text",
};

export const SIDEBAR_SHAPE_BUTTONS = {
  square: "square",
  lshape: "lshape",
  wideangle: "wideangle",
  rectangle: "rectangle",
  dot: "dot",
  freeDraw: "freeDraw",
  shapeFreeForm: "shapeFreeForm",
};

export const SIDEBAR_NAVIGATION_BUTTONS_LEVEL3 = {
  filters: "filters",
};

export const FREE_FORM_THICKNESS_POPUP_ID = "freeForm";

export const SIDEBAR_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.tools",
    shouldHardcodeMessage: true,
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true,
    subMenu: SIDEBAR_SHAPE_BUTTONS
  }, {
    menu: "layouts",
    message: "sqft.navigation.menu.layouts",
    hasMenu: true
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_TYPE_AREA_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true,
    subMenu: SIDEBAR_SHAPE_BUTTONS
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
];

export const SIDEBAR_CABINET_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_CABINET_BUTTONS
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },...(isDevMode() ? [{
    menu: "cabinetset",
    message: "Cabinet Set",
  }] : []),
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_3D_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_CABINET_BUTTONS
  }, ...(isDevMode() ? [{
    menu: "cabinetset",
    message: "Cabinet Set",
  }] : []),
];

export const SIDEBAR_WITH_FEATURES_SUBMENU = [
  SIDEBAR_NAVIGATION_BUTTONS.end_cap,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding,
  SQFT_FEATURES.top_cabinet,
  SQFT_FEATURES.bottom_cabinet,
  SQFT_FEATURES.tall_cabinet,
  SQFT_FEATURES.vanity_cabinet,
  SQFT_FEATURES.vanity_countertop,
];

export const RIGHT_SIDEBAR_WITH_FEATURES_SUBMENU = [
  SIDEBAR_NAVIGATION_BUTTONS.end_cap,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding,
];

export const SIDEBAR_HIDDEN_BUTTONS = {
  mitered: "mitered",
  toolWaterfall: "toolWaterfall",
  toolUnderlayment: "toolUnderlayment",
  buttonMitered: "buttonMitered",
  buttonCustomBacksplash: "buttonCustomBacksplash",
  buttonBacksplashFreeDraw: "buttonBacksplashFreeDraw",
  edgePeninsulaUnderwrap: "edgePeninsulaUnderwrap",
};

/*
* Hide shapes after removing them in popup window
*/
export const isDisabledInPopupShouldBeHidden = () => {
  return hardCodeIsCaesarStone() //enabled only for caesarstone
}

export const SIDEBAR_LAYOUTS_BUTTONS = [
  "S", "SP", "SI", "SPI", "SN", "SPN", "SNI", "SPNI", "L", "LI", "LN", "LNI"
];

export const SQFT_APPLIANCES = {
  hood: "hood",
  refrigerator: "refrigerator",
  range: "range",
  sink: "sink",
  doubleSink: "doubleSink",
  dishwasher: "dishwasher",
  iceMachine: "ice machine",
  oven: "oven",
  stovetop: "stovetop",
  trashCompactor: "trash compactor",
  wineFridge: "wine fridge"
};

export const SQFT_APPLIANCES_BATHROOM = {
  tub: "tub",
  toilet: "toilet",
  vanity: "vanity",
  wet_space: "wet space"
};

export const SQFT_APPLIANCES_CAES = {
  hood: "hood",
  sink: "sink",
  stovetop: "stovetop",
};

export const SQFT_APPLIANCES_ON_TOP_SHAPES = [
  SQFT_APPLIANCES.sink,
  SQFT_APPLIANCES.doubleSink
];

export const CABINET_LABELS = {
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
  tall_cabinet: 'tall_cabinet',
  crown_molding: 'crown_molding',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  handle: 'handle',
};

export const CABINET_BATHROOM_LABELS = {
  vanity_cabinet: 'vanity_cabinet',
  vanitie_cabinet_boxes: 'vanitie_cabinet_boxes',
  vanity_cabinet_boxes: 'vanity_cabinet_boxes',
};

export const CABINET_BOXES = [
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.vanitie_cabinet_boxes,
  SHAPE_PART_ID.vanity_cabinet_boxes,
];

export const SQFT_CABINET_APPLIANCES = {
  //hood: "hood",
  //microwave: "microwave",
};

export const SQFT_APPLIANCES_WITH_SUBMENU = [
  SQFT_APPLIANCES.oven,
  SQFT_APPLIANCES.hood,
  SQFT_APPLIANCES.dishwasher,
  SQFT_APPLIANCES.stovetop,
  SQFT_APPLIANCES.refrigerator,
  SQFT_APPLIANCES.range,
  SQFT_CABINET_APPLIANCES.microwave,
  //partIds which names are mismatched
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.fridge,
]

export const SQFT_SHAPES_THAT_ADD_OVERHANG = [
  SQFT_APPLIANCES.oven,
  SQFT_APPLIANCES.range,
  SQFT_APPLIANCES.hood,
  SQFT_APPLIANCES.dishwasher,
  SQFT_APPLIANCES.stovetop,
  SQFT_APPLIANCES.refrigerator,
  CABINET_LABELS.tall_cabinet_boxes,
  //CABINET_LABELS.lower_cabinet_boxes,
  //partIds which names are mismatched
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.fridge,
]

export const SQFT_MODE = {
  regular: "regular",
  slab: "slab",
};

export const SQFT_VIEW_MODE = {
  twoDMode: "2d Mode",
  threeDMode: "3d Mode",
  threeDModeDoors: "3d Mode Doors",
  threeDModeFramed: "Framed",
  threeDModeFrameless: "Frameless",
  augmentedReality: "Augmented Reality",
  augmentedRealityCabinet: "Augmented Reality Cabinet",
  augmentedRealityDoorsOnly: "Augmented Reality Doors Only"
}

export const SQFT_VIEW_3D_MODES = [
  SQFT_VIEW_MODE.threeDMode,
  SQFT_VIEW_MODE.threeDModeDoors,
  SQFT_VIEW_MODE.threeDModeFramed,
  SQFT_VIEW_MODE.threeDModeFrameless,
];

export const SQFT_VIEW_AR_MODES = [
  SQFT_VIEW_MODE.augmentedReality,
  SQFT_VIEW_MODE.augmentedRealityCabinet,
  SQFT_VIEW_MODE.augmentedRealityDoorsOnly,
]

export const MANUAL_CALCULATION_ROW_TYPES = {
  countertopRows: "countertopRows",
  backsplashRows: "backsplashRows",
  edgeRows: "edgeRows",
};

export const DIRECTION = {
  north: "north",
  east: "east",
  south: "south",
  west: "west",
};

export const MANUAL_CALCULATION_MEASURE = {
  length: "length",
  height: "height",
  width: "width",
  selectedFeature: "selectedFeature",
};

export const SQFT_BACKSPLASH_TYPES = ["4", "6", "18"];
export const SQFT_BACKSPLASH_TYPES_METRIC = ["100", "150", "600"];
export const SQFT_WALL_TYPES = ["wall"];
export const SQFT_MEASURE_UNIT = {
  imperial: "Imperial",
  metric: "Metric",
};
export const FREE_DRAW_TYPE = {
  shape: "shape",
  shapeFreeForm: "shapeFreeForm",
  wall: "wall",
  backsplash: "backsplash",
};

export const CONTEXT_MENU_TYPE = {
  list: "list",
  buttons: "buttons",
};

export const DEFAULT_EXPORTED_SQFT_FEATURES = [
  SQFT_FEATURES.crown_molding,
  SQFT_FEATURES.radius,
  SQFT_FEATURES.corners,
  SQFT_FEATURES.underlayment,
  SQFT_FEATURES.bumpouts,
]

export const PARENT_KEYS_WITH_COMBINED_FEATURES_IN_CART = [
  'edges',
  'edge',
  'backsplash',
  'backsplashes',
  'countertop',
  'center_island_countertop',
  'radius',
  'corners',
  'slabs',
  'vanity_countertop',
  'vanity_backsplash',
  'shower_wall',
  'shower_interior_wall',
  'shower_interior_wall_accent',
  'accent_wall',
  'shower_floor',
  'bathroom_floor',
  'kitchen_floor',
  'wall_a',
  'wall_b',
  'wall_c',
  'front_wall',
];

export const END_CAP_CABINETS_PART_IDS = [
  SQFT_FEATURES.wall_door_end_accessory,
  SQFT_FEATURES.base_door,
  SQFT_FEATURES.island_panel,
  SQFT_FEATURES.refridgerator_panel,
];

export const END_CAP_AREA_PART_IDS = [
  SQFT_FEATURES.end_cap,
];

export const END_CAP_PART_IDS = [
  ...END_CAP_CABINETS_PART_IDS,
  ...END_CAP_AREA_PART_IDS,
];

export const SQFT_PARENT_FEATURE_GROUP_PART_IDS = {
  upper_cabinet_boxes: 'top_cabinet',
  tall_cabinet_boxes: 'tall_cabinet',
  lower_cabinet_boxes: 'bottom_cabinet',
}

export const SQFT_CHILD_FEATURE_GROUP_PART_IDS = {
  top_cabinet: 'upper_cabinet_boxes',
  tall_cabinet: 'tall_cabinet_boxes',
  bottom_cabinet: 'lower_cabinet_boxes',
}

export const SQFT_CABINET_CHILD_FEATURE_GROUP_PART_IDS = {
  top_cabinet: 'upper_cabinet_boxes',
  tall_cabinet: 'tall_cabinet_boxes',
  bottom_cabinet: 'lower_cabinet_boxes',
}

export const SQFT_AREA_TYPE_PART_IDS = {
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
};

export const COUNTERTOP_LABELS = {
  center_island_countertop: 'center_island_countertop',
  countertop: 'countertop',
  vanity_countertop: 'vanity_countertop',
  vanity_accent: 'vanity_accent',
  shower_wall: 'shower_wall',
  shower_wall_accent: 'shower_wall_accent',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  accent_wall: 'accent_wall',
  shower_floor: 'shower_floor',
  bathroom_floor: 'bathroom_floor',
  kitchen_floor: 'kitchen_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
};

export const CABINET_PART_IDS_THAT_CAN_HAVE_HANDLES = [
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
]

export const HANDLE_TO_CABINETS = {
  [SQFT_FEATURES.top_handle]: [SQFT_FEATURES.upper_cabinet_boxes],
  [SQFT_FEATURES.bottom_handle]: [SQFT_FEATURES.lower_cabinet_boxes, SQFT_FEATURES.tall_cabinet_boxes],
  [SQFT_FEATURES.handle]: [SQFT_FEATURES.upper_cabinet_boxes, SQFT_FEATURES.lower_cabinet_boxes],
};

export const CABINETS_TO_HANDLE = {
  [SQFT_FEATURES.upper_cabinet_boxes]: SQFT_FEATURES.top_handle,
  [SQFT_FEATURES.lower_cabinet_boxes]: SQFT_FEATURES.bottom_handle,
  [SQFT_FEATURES.tall_cabinet_boxes]: SQFT_FEATURES.bottom_handle,
};

export const CABINET_PART_IDS_WITH_HALF_PRICE = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.tall_cabinet,
]

export const CABINET_PART_IDS = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.tall_cabinet,
]

export const CABINET_BATHROOM_PART_IDS = [
  SHAPE_PART_ID.vanity_cabinet,
]

export const CABINET_COMMON_COLOR_PART_IDS = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.tall_cabinet,
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
];

export const FEATURE_QUANTITY_UNITS = [
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.vanitie_cabinet_boxes,
  SHAPE_PART_ID.vanity_cabinet_boxes,
];

//this part ids used to remove buttons if there are no features
export const HIDE_MENU_WITH_NO_FEATURES = [
  SHAPE_PART_ID.tall_cabinet,
  ...END_CAP_CABINETS_PART_IDS,
  SQFT_FEATURES.bottom_handle,
  SQFT_FEATURES.countertop,
  SQFT_FEATURES.vanity_countertop,
  SQFT_FEATURES.hinge,
  SQFT_FEATURES.crown_molding
];

export const BACKSPLASH_LABELS = {
  backsplash: 'backsplash',
  backsplashes: 'backsplashes',
  vanity_backsplash: 'vanity_backsplash',
};

export const EDGE_LABELS = {
  edge: 'edge',
  edge_profile: 'edge_profile',
  center_island_edge: 'center_island_edge',
};

export const CORNER_LABELS = {
  radius: 'radius',
  corner: 'corner',
};

export const SHOULD_DISPLAY_FEATURES_ONLY_WITH_AR3DUrls = [
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding,
  SQFT_FEATURES.top_cabinet,
  SQFT_FEATURES.bottom_cabinet,
  SQFT_FEATURES.tall_cabinet,
  SQFT_FEATURES.vanity_cabinet,
  SQFT_FEATURES.upper_cabinet_boxes,
  SQFT_FEATURES.lower_cabinet_boxes,
  SQFT_FEATURES.tall_cabinet_boxes,
  SQFT_FEATURES.vanity_countertop,
  ...SQFT_APPLIANCES_WITH_SUBMENU,
];

// export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = [
//   SQFT_FEATURES.backsplashes,
//   SQFT_FEATURES.countertop,
//   SQFT_FEATURES.center_island_countertop,
//   SQFT_FEATURES.shower_wall,
//   SQFT_FEATURES.shower_floor,
//   SQFT_FEATURES.kitchen_floor,
//   SQFT_FEATURES.vanity_countertop,
//   SQFT_FEATURES.vanity_backsplash,
//   SQFT_FEATURES.shower_interior_wall,
//   SQFT_FEATURES.shower_interior_wall_accent,
//   SQFT_FEATURES.bathroom_floor,
//   SQFT_FEATURES.wall_a,
//   SQFT_FEATURES.wall_b,
//   SQFT_FEATURES.wall_c
// ];

export const SHAPE_PART_IDS_USING_SAME_COLOR = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
  waterfallPiece: SHAPE_PART_ID.waterfallPiece,
  backsplashPiece: SHAPE_PART_ID.backsplashPiece,
  seamPiece: SHAPE_PART_ID.seamPiece,
}

export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
}

export const ALLOWED_LABEL_NAV_ITEMS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
  ...CABINET_LABELS,
  ...CABINET_BATHROOM_LABELS,
  ...SQFT_AREA_TYPE_PART_IDS,
  ...END_CAP_PART_IDS
}

export const POINT_PROPERTY = {
  angle: 'angle',         // 45 degCorner
  arcLength: 'arcLength', // Radius
}

export const POINT_PROPERTY_PART_ID = {
  [POINT_PROPERTY.angle]: 'corners',
  [POINT_PROPERTY.arcLength]: 'radius',
}

export const RESOURCE_TYPE = {
  attachedToLine: 'attachedToLine',
  waterfallSectionsData: 'waterfallSectionsData',
  underlaymentSections: 'underlaymentSections',
  selectedFeature: null
}

export const RESOURCE_ATTACHED_TO_TYPE = {
  edge: 'edge',
  backsplash: 'backsplash',
  wall: 'wall',
  mitered: 'mitered',
  underlayment: 'underlayment',
  bumpout: 'bumpout',
  waterfall: 'waterfall',
  crown_molding: 'crown_molding',
  end_cap: 'end_cap',
}

export const RESOURCE_ATTACHED_TO_NAME = {
  waterfall: 'Waterfall',
}

export const WORKSPACE_RESOURCES = {
  spacers: 'spacers',
  handles: 'handles',
  hinge: 'hinge',
  crownMolding: 'crownMolding',
  walls: 'walls',
  shapeColors: 'shapeColors',
  waterfall: 'waterfall',
  removedFeatures: 'removedFeatures',
  snappedShapeGroups: 'snappedShapeGroups',
  selectedShapes: 'selectedShapes',
  images3d: 'images3d',
  images3dAutoSaved: 'images3dAutoSaved',
}

/**
 * Should be unique
 * @type {{peninsulaUnderwrap: string, underlayment: string, waterfall: string, cabinetReturn: string, overhangReturn: string}}
 */
export const WATERFALL_SHAPES_KEY = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Ppeninsula Underwrap',
}

export const WATERFALL_SHAPES_NAME = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Underlayment',
}

export const SQFT_GROUP_DROPDOWN = {
  cabinets: 'cabinets',
  countertop: 'countertop',
}

export const SQFT_GROUP = {
  area: 'area',
  cabinets: 'cabinets',
  default: 'default',
}

export const SQFT_AR3D_POPUP_CONTENT_TYPE = {
  ar: 'ar',
  threeD: 'threeD',
}

export const SQFT_AR3D_GLB_VIEWER = {
  singleModel: 'singleModel',
  separateModels: 'separateModels',
}

export const MITER_UNDERWRAP_EDGE_NAMES = [
  "miter underwrap"
];

/**
 * Additional material ( miter edge height is taken from edge name (except Rimrock - 981))
 * @type {string[]}
 */
export const MITER_EDGE_NAMES = [
  'Miter 1 1/2"',
  'Miter 2"-3"',
  'Miter 4"-6"',
  'Miter Edge',
  'Mitered Edge',
  'Rimrock - 981',
  'Ingletado',
  'Inglete',
  'Inglete.',
  'Edge build-up',
  '2cm Mitered',
  '3cm Mitered',
  '4cm Mitered',
  '5cm Mitered',
]

export const WATERFALL_OVERLAY_TYPE = {
  waterfall: 'waterfall',
  peninsulaUnderwrap: 'peninsulaUnderwrap',
}

export const MITERED_OVERLAY_TYPE = {
  mitered: "mitered",
  underlayment: "underlayment",
}

export const APPLIANCES_THAT_SHOULD_RENDER_MEASUREMENTS_INSIDE_THE_SHAPE = [
  SQFT_APPLIANCES.sink,
  SQFT_APPLIANCES.doubleSink,
  SQFT_APPLIANCES.stovetop
]

export const CABINET_FILTER_NAMES = {
  knobs: 'Number_of_Knobs',
  hinges: 'Number_of_Hinges',
  slideSets: 'Numbe_of_Slide_Sets',
  doors: 'Number_of_Doors',
  drawers: 'Number_of_Drawers',
}

export const FEATURE_PICKER_TYPE = {
  handles: 'HANDLES_CHANGE',
  hinges: 'HINGE_CHANGE',
  shape: 'SHAPE_CHANGE',
}

export const ALLOWED_STYLE_COLOR = {
  "diamond": [
    "ADOBE rPET","ALOE SUPERMATTE","BAJA rPET","BISQUE","FASHIONISTA","FREE SPIRIT",
    "HAZE SUPERMATTE","LOVE AT FIRST SIGHT","MIDNIGHT SUPERMATTE","MIST SUPERMATTE",
    "NIZZA","NORDIC WHITE SUPERMATTE","OASIS rPET","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "ROJA rPET","RUSTIC LIGHT OAK","SAGE SUPERMATTE","SHEER BEAUTY",
    "SILT SUPERMATTE (Stone Grey)","SNOW WHITE (White Lacquer)","STRATUS SUPERMATTE",
    "WHITE SMARTMATTE","WINTER FUN","BLACK SMARTMATTE"
  ],
  "7500": [
    "ADOBE rPET","ALOE SUPERMATTE","BAJA rPET","BISQUE","FASHIONISTA","FREE SPIRIT",
    "HAZE SUPERMATTE","LOVE AT FIRST SIGHT","MIDNIGHT SUPERMATTE","MIST SUPERMATTE",
    "NIZZA","NORDIC WHITE SUPERMATTE","OASIS rPET","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "ROJA rPET","RUSTIC LIGHT OAK","SAGE SUPERMATTE","SHEER BEAUTY",
    "SILT SUPERMATTE (Stone Grey)","SNOW WHITE (White Lacquer)","STRATUS SUPERMATTE",
    "WHITE SMARTMATTE","WINTER FUN","BLACK SMARTMATTE"
  ],
  "10900": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE"
  ],
  "shaker shallow": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE",
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "shaker slim": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE",
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "900": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE",
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "aspen": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE",
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "tm403 csoo": [
    "LOVE AT FIRST SIGHT","MIST SUPERMATTE","NORDIC WHITE SUPERMATTE","PALOMINO",
    "PELEE ISLAND PEAR","ROGUE VALLEY PEAR","HAZE SUPERMATTE","NIZZA",
    "SNOW WHITE (White Lacquer)","WINTER FUN"
  ],
  "tm405": ["FASHIONISTA"],
  "tm504 skoo": [
    "MIST SUPERMATTE","NORDIC WHITE SUPERMATTE","PALOMINO","NIZZA",
    "SNOW WHITE (White Lacquer)","WINTER FUN"
  ],
  "tm506": ["FASHIONISTA","FREE SPIRIT"],
  "tm404": ["POLAR WHITE"],

  "london 10900": [
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "london 900": [
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "london 10500": [
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ]
};


export const FEATURES_WITH_DISABLED_RESIZING = ['SW-BES12L Base Cabinet', 'SW-BES12R Base Cabinet'];

export const CABINET_SET5_KITCHEN_MAGIK = {
  "bumpouts": [],
  "canvasImage": "",
  "sqFtSlabImage": "",
  "sqFtSlabCalcImage": "",
  "sqftApplianceImages": "",
  "images3D": "",
  "slabImages": [],
  "measureUnit": "Imperial",
  "sinks": [],
  "radii": [],
  "corners": [],
  "totalInches": 14112,
  "shapeLength": 14,
  "objIds": 14,
  "removedFeatures": [],
  "textBoxes": [],
  "slabAdditionalShapesList": [],
  "slabImagesTotalArea": [],
  "squareFeet": 98,
  "countertops": [
    {
      "pos": {
        "x": -107.1333333333333,
        "y": -33.86666666666668
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 1,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "72b63da4-66c7-45f0-b329-3bff89eb9538",
          "from": {
            "id": "59c85421-bfea-4676-8b14-de8a67824aea",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0e38b507-572e-43ae-9f6d-9d36c9df126c",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c073ef20-b926-415f-a47f-ca973a8fcd9f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "ba913124-6c95-4435-bb48-3098a10ac70c",
          "from": {
            "id": "0e38b507-572e-43ae-9f6d-9d36c9df126c",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "366cda51-8a77-4bc6-a9d3-4222231c0bcd",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5d6ed938-b222-425a-b545-01ab6ab09041",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "565ce0e6-42af-4613-9f1e-b03284b5f927",
          "from": {
            "id": "366cda51-8a77-4bc6-a9d3-4222231c0bcd",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "9a523566-69cb-4054-89c1-b8e29e300154",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e8371e5a-145d-4e51-a51d-6a703e14e963",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1bcb2a79-dc8e-431b-9ea8-d8da20b14d25",
          "from": {
            "id": "9a523566-69cb-4054-89c1-b8e29e300154",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "59c85421-bfea-4676-8b14-de8a67824aea",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "98cd22c5-01ce-47ac-a7b6-083cb28dc7be",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -104.73333333333329,
          "y": -35.999999999999986
        },
        "intersectionPoints": [],
        "snappedWithShape": 10,
        "snappedShapeGroup": 62
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "59c85421-bfea-4676-8b14-de8a67824aea"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "0e38b507-572e-43ae-9f6d-9d36c9df126c"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "366cda51-8a77-4bc6-a9d3-4222231c0bcd"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "9a523566-69cb-4054-89c1-b8e29e300154"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -107.13333333333331,
        "y": -152.80000000000015
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 2,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "68673bdb-08fe-4be9-b4f1-1911707986f6",
          "from": {
            "id": "aaf5fa2f-5674-4c91-9fe1-3762ffa63d7b",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8f4a11af-98f1-455d-937f-520051456bb4",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5439eec1-1803-4bb5-8527-8423ad7d34dd",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2ec696c8-5111-4e47-8912-5e08688bcbce",
          "from": {
            "id": "8f4a11af-98f1-455d-937f-520051456bb4",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "59b23754-d47b-44f5-bfb8-6f3adeec93d6",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "95760f53-28fc-4cf5-ac10-43842f3c6342",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1bd911b7-7b53-4625-acab-e054082e583b",
          "from": {
            "id": "59b23754-d47b-44f5-bfb8-6f3adeec93d6",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "ab93e8a0-a13c-4314-9783-49067aec500f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4706ed39-e8ae-447f-9ed6-087090dac54f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e966bca8-3f8e-41ba-8893-12f6bb5d0f9f",
          "from": {
            "id": "ab93e8a0-a13c-4314-9783-49067aec500f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "aaf5fa2f-5674-4c91-9fe1-3762ffa63d7b",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4bec7227-bdb1-42f5-9696-679798cbd682",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -108.06666666666665,
          "y": -153.86666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 14,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "aaf5fa2f-5674-4c91-9fe1-3762ffa63d7b"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "8f4a11af-98f1-455d-937f-520051456bb4"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "59b23754-d47b-44f5-bfb8-6f3adeec93d6"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "ab93e8a0-a13c-4314-9783-49067aec500f"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -18.333333333333492,
        "y": -35.99999999999997
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 3,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "3294a4e1-6a22-4e91-b618-5dcd8ee79c9b",
          "from": {
            "id": "e8305809-6d7d-4d14-91c4-e5fb8e97520d",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "ec5e184b-cfbc-4c35-9a9d-67d91ca9d982",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e5ecc07d-f158-4476-bbd5-7512db0d4a79",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "9ae3c326-3e7a-4547-b3d2-7b41fd3e1f00",
          "from": {
            "id": "ec5e184b-cfbc-4c35-9a9d-67d91ca9d982",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "f537a66b-010e-4732-bd86-c034248b96e4",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "143bc8f1-f740-47c9-baec-c0c66f393821",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2317431f-d9ea-4001-b9eb-c1613066834d",
          "from": {
            "id": "f537a66b-010e-4732-bd86-c034248b96e4",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4ed58fbf-cf14-412e-80b7-f3d83e8eb260",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "17303f8d-96fb-48bf-8866-5494e7530909",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2493867e-32f2-4ad1-a460-523256892cc9",
          "from": {
            "id": "4ed58fbf-cf14-412e-80b7-f3d83e8eb260",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "e8305809-6d7d-4d14-91c4-e5fb8e97520d",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "093cfff7-741f-48f9-bbad-d11eb3081a71",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -20.733333333333313,
          "y": -35.99999999999997
        },
        "intersectionPoints": [],
        "snappedWithShape": 4,
        "snappedShapeGroup": 62
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "e8305809-6d7d-4d14-91c4-e5fb8e97520d"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "ec5e184b-cfbc-4c35-9a9d-67d91ca9d982"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "f537a66b-010e-4732-bd86-c034248b96e4"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "4ed58fbf-cf14-412e-80b7-f3d83e8eb260"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 20.33333333333333,
        "y": -35.73333333333338
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 4,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "7c6595ad-451f-4b75-a2a4-c464762a372b",
          "from": {
            "id": "3ba5954d-76a8-47b4-992c-35839a53e7a6",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0d145e92-98e7-4920-ae04-865e9c5cc34d",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6519e405-e974-4013-9390-c9031e46739a",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "599fcec7-6b66-4d25-821a-562867681288",
          "from": {
            "id": "0d145e92-98e7-4920-ae04-865e9c5cc34d",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "abdacd35-acc9-4256-8b29-89db93907ef8",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "ce64cd56-ce53-4e30-a423-26d2bbebaf95",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a79a7a4b-3e8c-4eb0-8ca6-d6bd5cd759aa",
          "from": {
            "id": "abdacd35-acc9-4256-8b29-89db93907ef8",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "f813063b-7137-4006-81ee-6ed1625ef725",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "59d38ae1-26c1-40a7-a936-5cd8be41c3b4",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "fed03798-8e89-42fc-a79f-bff4676a4af7",
          "from": {
            "id": "f813063b-7137-4006-81ee-6ed1625ef725",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3ba5954d-76a8-47b4-992c-35839a53e7a6",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "a82014dd-b1b0-4c61-aff2-a950e71d9f99",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 21.26666666666669,
          "y": -35.99999999999995
        },
        "intersectionPoints": [],
        "snappedWithShape": 3,
        "snappedShapeGroup": 62
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "3ba5954d-76a8-47b4-992c-35839a53e7a6"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "0d145e92-98e7-4920-ae04-865e9c5cc34d"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "abdacd35-acc9-4256-8b29-89db93907ef8"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "f813063b-7137-4006-81ee-6ed1625ef725"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 49.93333333333339,
        "y": -97.33333333333336
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 5,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "e98fea7e-3018-477c-bb06-3c1f928ad35f",
          "from": {
            "id": "b3e1b39c-2077-48d9-a403-4b0dac45b57d",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "607363ec-050b-4566-b0b0-d6f0c7d484a6",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "25b10bc2-9d0e-4799-a9b9-7028bec2c184",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2bcd3fb6-743a-4a7a-96ba-a039281c0cb8",
          "from": {
            "id": "607363ec-050b-4566-b0b0-d6f0c7d484a6",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7c903ca6-422f-4cb2-97a6-544894818085",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e4f2da2c-44ab-4f4a-ba56-66f82d8a8eaa",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "00d68c28-f79f-489d-ad3c-00ee4133c65f",
          "from": {
            "id": "7c903ca6-422f-4cb2-97a6-544894818085",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "2d2ef3ad-0c91-4ea1-a478-f86c258530f4",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "221e9f54-ec20-49cf-bd39-0dc6bdeec691",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "48cc27ab-bee5-44a5-94f7-996850f85f28",
          "from": {
            "id": "2d2ef3ad-0c91-4ea1-a478-f86c258530f4",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b3e1b39c-2077-48d9-a403-4b0dac45b57d",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6ac7562d-deb9-42a7-bc56-84b3cb6d8563",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 49.93333333333332,
          "y": -98.13333333333331
        },
        "intersectionPoints": [],
        "snappedWithShape": 6,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "b3e1b39c-2077-48d9-a403-4b0dac45b57d"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "607363ec-050b-4566-b0b0-d6f0c7d484a6"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "7c903ca6-422f-4cb2-97a6-544894818085"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "2d2ef3ad-0c91-4ea1-a478-f86c258530f4"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 7.799999999999996,
        "y": -96.2666666666667
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 6,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "e0119535-700b-4fd6-a310-9900d972bc5f",
          "from": {
            "id": "bc788d51-38fa-498e-86da-c6d2851ef497",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0203f8f9-e347-4697-8bf6-190f8c206141",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "1ee43218-a96d-4df7-9cc0-134e43c1e94c",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "41814718-ea3e-4155-b57c-14333279d568",
          "from": {
            "id": "0203f8f9-e347-4697-8bf6-190f8c206141",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8ac6525d-95a9-41e0-a53e-19d75b508f6b",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "b22a6327-417c-4c09-8a00-c1b436c3c002",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "ebf213a7-2cd0-41b9-a900-8803a8526a97",
          "from": {
            "id": "8ac6525d-95a9-41e0-a53e-19d75b508f6b",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "1fb26e9e-03e8-4d8b-95fa-b927fffd4349",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "cb44504d-3184-4f99-95b0-93846d9c37b9",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "f5df7ca4-8809-480d-9d50-bc860554eb77",
          "from": {
            "id": "1fb26e9e-03e8-4d8b-95fa-b927fffd4349",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "bc788d51-38fa-498e-86da-c6d2851ef497",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "ad3b5984-008c-4d10-b8ed-0e1df3bfd36b",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 7.93333333333333,
          "y": -98.13333333333331
        },
        "intersectionPoints": [],
        "snappedWithShape": 5,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "bc788d51-38fa-498e-86da-c6d2851ef497"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "0203f8f9-e347-4697-8bf6-190f8c206141"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "8ac6525d-95a9-41e0-a53e-19d75b508f6b"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "1fb26e9e-03e8-4d8b-95fa-b927fffd4349"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -33.8,
        "y": -98.13333333333335
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 7,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "dc8df901-efbc-4dcd-9c0d-b21e49935d03",
          "from": {
            "id": "13158ed3-4f96-410c-b585-f077a6b51724",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "9a6c4ef9-6a54-4cb7-b774-5c5c36497e7f",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "7882e95a-ee99-438f-92d8-712005702630",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "056bc07a-0086-4df6-868c-d44437b2d963",
          "from": {
            "id": "9a6c4ef9-6a54-4cb7-b774-5c5c36497e7f",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0a549c4d-f9bf-429e-a69c-8fb996e4d44a",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "63963176-66f0-4ff5-a733-915a3d3fb2eb",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e56741b5-c4b7-4444-89a3-8bb2a784f638",
          "from": {
            "id": "0a549c4d-f9bf-429e-a69c-8fb996e4d44a",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d9e0ffae-6cf7-45f6-9746-df115bd8774e",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "18b451d1-6f57-4aca-a1b1-906e2aa46f47",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "fe56168e-fda9-4cce-b108-412271cc7daf",
          "from": {
            "id": "d9e0ffae-6cf7-45f6-9746-df115bd8774e",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "13158ed3-4f96-410c-b585-f077a6b51724",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "21c9a877-5b03-4ffd-ad6d-17794e5760bf",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -34.06666666666666,
          "y": -98.13333333333331
        },
        "intersectionPoints": [],
        "snappedWithShape": 8,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "13158ed3-4f96-410c-b585-f077a6b51724"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "9a6c4ef9-6a54-4cb7-b774-5c5c36497e7f"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "0a549c4d-f9bf-429e-a69c-8fb996e4d44a"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "d9e0ffae-6cf7-45f6-9746-df115bd8774e"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -76.99999999999999,
        "y": -98.4
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 8,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "dab0d19c-bf07-41de-83c1-117197ddf0b0",
          "from": {
            "id": "4d4e39b8-6234-45e0-9ecc-86dbfee018cb",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "073c5e6a-6377-40c1-b502-64c7f24c7935",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "db2c9cb3-47fd-4ada-aaa6-ad80114ecd58",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "78b14a01-e50b-42ad-a204-8b3a3af74aaa",
          "from": {
            "id": "073c5e6a-6377-40c1-b502-64c7f24c7935",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "807a58c7-4097-4be5-a197-1d4980168423",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "8cc8af75-301a-4a17-ba1f-46626d769b37",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "7ed0c1aa-0b46-439a-99cb-150a54dbd484",
          "from": {
            "id": "807a58c7-4097-4be5-a197-1d4980168423",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b78b40c3-b87a-4dd5-b95f-34472c53feb9",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e0fd84d3-2423-4055-9edf-792fe9f81687",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "565c0f9b-a963-472a-af4f-2c6ab50e8b44",
          "from": {
            "id": "b78b40c3-b87a-4dd5-b95f-34472c53feb9",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4d4e39b8-6234-45e0-9ecc-86dbfee018cb",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "ebe4ff6a-cf08-4c53-8ba5-0dbf4a55bf78",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -76.06666666666665,
          "y": -98.1333333333333
        },
        "intersectionPoints": [],
        "snappedWithShape": 7,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "4d4e39b8-6234-45e0-9ecc-86dbfee018cb"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "073c5e6a-6377-40c1-b502-64c7f24c7935"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "807a58c7-4097-4be5-a197-1d4980168423"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "b78b40c3-b87a-4dd5-b95f-34472c53feb9"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -118.06666666666665,
        "y": -98.13333333333328
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 9,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "8c18e1eb-944b-4482-9fb1-5f465061a374",
          "from": {
            "id": "e46e425c-b680-4208-ad92-6cad3abd555b",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c74dbd94-ad31-4bb6-9f08-b7b1152a0b36",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c938a14c-0f83-4256-9119-62258168f418",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "0cdb2f4f-0edb-492f-b90f-76cc9d452cab",
          "from": {
            "id": "c74dbd94-ad31-4bb6-9f08-b7b1152a0b36",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "dea979ab-baea-4d38-aa56-d3283f2ad084",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "fbf09684-64d0-4ddd-84c1-db21766b2e43",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "624e1570-5491-491a-a425-118cce461fe2",
          "from": {
            "id": "dea979ab-baea-4d38-aa56-d3283f2ad084",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a429d8e1-c111-4be5-9204-363a4eee4345",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "467d015c-a459-48cb-af42-afda6bc460c1",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "8544fbdc-6bc2-488c-bd13-2a61bc6ae2cb",
          "from": {
            "id": "a429d8e1-c111-4be5-9204-363a4eee4345",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "e46e425c-b680-4208-ad92-6cad3abd555b",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "fddaf1fb-0f50-4631-ba7d-5a32d087ca73",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": null,
        "intersectionPoints": [],
        "snappedWithShape": 8,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "e46e425c-b680-4208-ad92-6cad3abd555b"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "c74dbd94-ad31-4bb6-9f08-b7b1152a0b36"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "dea979ab-baea-4d38-aa56-d3283f2ad084"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "a429d8e1-c111-4be5-9204-363a4eee4345"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -63.66666666666667,
        "y": -35.73333333333334
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 10,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "d727b069-c2ab-48d2-9ea9-b05ec82c6588",
          "from": {
            "id": "01b3cedf-69b9-4ec5-bc19-7c934aa6c2ba",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4f583cba-bcc6-4953-b11f-9bc1fb9e7d37",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "af8df081-83e7-44ea-8974-9eb4e9d25e37",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1d618bc6-9a7f-4fde-8faf-71a8de10b890",
          "from": {
            "id": "4f583cba-bcc6-4953-b11f-9bc1fb9e7d37",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "87c1ea7c-06fb-46d6-97f0-c076c6099c8b",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9c2e13e7-5ee2-4118-9440-efe25922effd",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "28cadc5e-29d6-4bd9-80d2-8a23ea02a156",
          "from": {
            "id": "87c1ea7c-06fb-46d6-97f0-c076c6099c8b",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "24c51695-94e4-475f-9f56-2c4757300e0b",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "cc277364-e377-415c-8fee-01f9896fccd7",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "163b7d53-dc23-4164-8f39-b638887083ba",
          "from": {
            "id": "24c51695-94e4-475f-9f56-2c4757300e0b",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "01b3cedf-69b9-4ec5-bc19-7c934aa6c2ba",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5b859230-28eb-4f9d-8649-d892906537b0",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -62.733333333333306,
          "y": -35.99999999999998
        },
        "intersectionPoints": [],
        "snappedWithShape": 3,
        "snappedShapeGroup": 62
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "01b3cedf-69b9-4ec5-bc19-7c934aa6c2ba"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "4f583cba-bcc6-4953-b11f-9bc1fb9e7d37"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "87c1ea7c-06fb-46d6-97f0-c076c6099c8b"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "24c51695-94e4-475f-9f56-2c4757300e0b"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 59.266666666666666,
        "y": -155.73333333333343
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 11,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "379cf499-c46c-4bb8-9dbb-ccd85746a6d9",
          "from": {
            "id": "3e625b1b-0df8-4763-8078-57074aea19b6",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "1090853e-0100-493d-93c8-dce307d266ea",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "760c9c37-ab7c-4a75-aa7a-8179f89b412f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a1470c27-d237-474c-be2c-78a8ef1afed5",
          "from": {
            "id": "1090853e-0100-493d-93c8-dce307d266ea",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c0097547-0863-48c4-a96b-bfde1565229c",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "d6ef00e0-8dff-44d9-af66-ae257d4531b0",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "0ca2a835-b705-41e3-bca2-cb99ecf1f2cf",
          "from": {
            "id": "c0097547-0863-48c4-a96b-bfde1565229c",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "41088237-c63f-4e83-a1c8-c8edef8d699f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "13f478c7-88d1-4e82-b4ef-a1f90b73ee2d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "09581b95-ce1d-4a49-824c-f4162dabb8ee",
          "from": {
            "id": "41088237-c63f-4e83-a1c8-c8edef8d699f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3e625b1b-0df8-4763-8078-57074aea19b6",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "8886e3b4-0399-4621-962e-b059fa98810e",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 59.93333333333333,
          "y": -153.86666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 12,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "3e625b1b-0df8-4763-8078-57074aea19b6"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "1090853e-0100-493d-93c8-dce307d266ea"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "c0097547-0863-48c4-a96b-bfde1565229c"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "41088237-c63f-4e83-a1c8-c8edef8d699f"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 15,
        "y": -154.6666666666668
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 12,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "5c5d1b18-9ae3-4f55-8fc1-095181050f44",
          "from": {
            "id": "b6df1f8f-1f92-4723-86ea-3278b90624f7",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d6538f7a-a5b3-458f-a8a6-173c79d5d773",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "bce04f38-226f-48e4-8a6e-b763b8c2c923",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "4c99d655-52a6-4184-bebc-8655388c6744",
          "from": {
            "id": "d6538f7a-a5b3-458f-a8a6-173c79d5d773",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5c562bd9-754a-4511-89fb-1f0f98ec23c3",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "da7411a2-6f0b-429f-ae23-40568f90dae3",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "64eef1c6-cb48-46d1-afb4-a8fc7f5f3f1d",
          "from": {
            "id": "5c562bd9-754a-4511-89fb-1f0f98ec23c3",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "35de0083-4c8b-4e27-aebb-e7ee8424c458",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "8dd9f446-be38-4eeb-a8e8-6283a932d896",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "28a7be72-19df-444e-a16a-076a6a2f25e9",
          "from": {
            "id": "35de0083-4c8b-4e27-aebb-e7ee8424c458",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b6df1f8f-1f92-4723-86ea-3278b90624f7",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "341e8c1d-adc4-495f-b1d4-1d3b63dfa548",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 17.933333333333334,
          "y": -153.86666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 11,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "b6df1f8f-1f92-4723-86ea-3278b90624f7"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "d6538f7a-a5b3-458f-a8a6-173c79d5d773"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "5c562bd9-754a-4511-89fb-1f0f98ec23c3"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "35de0083-4c8b-4e27-aebb-e7ee8424c458"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -24.2,
        "y": -153.33333333333337
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 13,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "86c61155-7955-4add-a3c6-60eec9084bc3",
          "from": {
            "id": "c498ff03-1784-4870-be66-722d8d2f8417",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3fc84807-452e-4b8f-adf1-c8bfcb6048da",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "39163e1b-1f6a-4f97-8302-f076d8e33cee",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "ffdf56a8-348e-4b61-bf9c-9020954a773a",
          "from": {
            "id": "3fc84807-452e-4b8f-adf1-c8bfcb6048da",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4ee7b621-10fe-4523-bda3-cea61413aa13",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "47c8bebf-0ac6-42e0-9b83-cb90d6e2dea4",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "627cb9a3-cfb5-470c-b87a-7ea04eb72229",
          "from": {
            "id": "4ee7b621-10fe-4523-bda3-cea61413aa13",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3414da45-363c-46c2-b3e9-392f5169d48e",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "f171bd6a-d44c-465e-a6bc-d064ac09b931",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "21b36def-ee23-47c5-b9db-9bf3ba1ec39a",
          "from": {
            "id": "3414da45-363c-46c2-b3e9-392f5169d48e",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c498ff03-1784-4870-be66-722d8d2f8417",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "700af38e-23ec-4bcd-8856-beceb0d2b6d6",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -24.066666666666666,
          "y": -153.86666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 12,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "c498ff03-1784-4870-be66-722d8d2f8417"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "3fc84807-452e-4b8f-adf1-c8bfcb6048da"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "4ee7b621-10fe-4523-bda3-cea61413aa13"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "3414da45-363c-46c2-b3e9-392f5169d48e"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -66.06666666666665,
        "y": -153.86666666666667
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 14,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "4402c4c5-a638-468d-ab4e-0ea95450803f",
          "from": {
            "id": "015ed91a-2772-43b1-97c6-90bacaa6b8cc",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5cc6e2e9-656a-4bdc-921a-6cb309f9073a",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c745fbad-a1b7-4754-b139-4f226978c3fa",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a2f85fd6-4a45-454f-8cb5-232e15bb2aaf",
          "from": {
            "id": "5cc6e2e9-656a-4bdc-921a-6cb309f9073a",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "66ba7a49-b06f-4efa-a95d-8b62c18b9bb2",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e9e64aff-3ed3-4862-9569-9b019dc312e8",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "0f955639-1909-4d85-9156-55490f37739f",
          "from": {
            "id": "66ba7a49-b06f-4efa-a95d-8b62c18b9bb2",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "ef17d82b-4ba9-4fbf-9192-4ce544ca0b89",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "25795a12-d606-4b2b-9c6b-1bb20e3034e3",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "69583501-cd01-454b-9349-4179ff4e4d15",
          "from": {
            "id": "ef17d82b-4ba9-4fbf-9192-4ce544ca0b89",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "015ed91a-2772-43b1-97c6-90bacaa6b8cc",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c93a6694-33e5-4cfd-813e-ff0490e2099d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": null,
        "intersectionPoints": [],
        "snappedWithShape": 2,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "015ed91a-2772-43b1-97c6-90bacaa6b8cc"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "5cc6e2e9-656a-4bdc-921a-6cb309f9073a"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "66ba7a49-b06f-4efa-a95d-8b62c18b9bb2"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "ef17d82b-4ba9-4fbf-9192-4ce544ca0b89"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    }
  ],
  "manualCalculate": false,
  "controllers": {
    "walls": [],
    "snappedShapeGroups": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62
    ],
    "handles": [],
    "hinge": []
  },
  "underlayment": []
}
